// Icons
const list = [
  {
    name: "Dashboard",
   for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/dashboard",
    active: false,
  },
  {
    name: "Zone Management",
  for:["ADMIN"],
  //icon: Public,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Zone management.png",
    active: false,
    subMenu: [
      { name: "Add Location", for:["ADMIN"], /*icon : AddLocation ,*/  src: "/assets/images/sidebar_icons_2.0/Add location.png", subLink: "/add-location" },
      { name: "List Location", for:["ADMIN"],/*icon : List ,*/ src: "/assets/images/sidebar_icons_2.0/LIst location.png", subLink: "/list-location" },
      { name: "Restrict Location", for:["ADMIN"],/*icon : WrongLocation ,*/  src: "/assets/images/sidebar_icons_2.0/Restrictlocation.png", subLink: "/restrict-location" },
    ],
  },
  {
    name: "Members",
    for:["ADMIN","DISPATCHER","SUB COMPANY"],
 // icon: Diversity3,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Member.png",
    active: false,
    subMenu: [
      { name: "Passenger", for:["ADMIN","DISPATCHER"], /*icon: Hail,*/  src: "/assets/images/sidebar_icons_2.0/Passenger.png", subLink: "/passenger" },
      { name: "Barber", for:["ADMIN","DISPATCHER","SUB COMPANY"] ,/*icon: SensorOccupied,*/   src: "/assets/images/sidebar_icons_2.0/iconbarber.png", subLink: "/driver" },
      { name: "Dispatcher", for:["ADMIN"],/*icon: SupportAgent,*/  src: "/assets/images/sidebar_icons_2.0/Dispatcher.png" , subLink: "/dispatcher" },
      { name: "Sub Company", for:["ADMIN"], /*icon: MeetingRoom ,*/  src: "/assets/images/sidebar_icons_2.0/Sub-company.png", subLink: "/sub-company" },
      { name: "Account Manager", for:["ADMIN"], /*icon: AdminPanelSettings ,*/  src: "/assets/images/sidebar_icons_2.0/Account Manager.png", subLink: "/account-manager" },
    { name: "Corporate", for:["ADMIN"], /*icon: CorporateFare ,*/ src: "/assets/images/sidebar_icons_2.0/Corporate.png", subLink: "/corporate" },
     { name: "Hotel/Restaruant", for:["ADMIN"], /*icon: Luggage ,*/  src: "/assets/images/sidebar_icons_2.0/Hotel.png", subLink: "/hotel" },
     // { name: "Customer Care", for:["ADMIN"], /*icon: HeadsetMic ,*/  src: "/assets/images/sidebar_icons_2.0/Customer Care.png", subLink: "#" },
     // { name: "Payroll", for:["ADMIN"], /*icon: Receipt ,*/ src: "/assets/images/sidebar_icons_2.0/Payroll.png", subLink: "#" },
     // { name: "Sub Admin", for:["ADMIN"], /*icon: SupervisorAccount,*/ src: "/assets/images/sidebar_icons_2.0/Sub Admin.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Quotation Trip",
  //   isCollapsible: false,
  //  for:["ADMIN"],
 //   icon: ModeOfTravel, 
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/Quotation  trip.png",
  //   link: "#",
  //   active: false,
  // },

  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Report.png",
    for:["ADMIN","ACCOUNT MANAGER"],
 // icon: Report, 
    active: false,
    subMenu: [
      { name: "Overall Ride Statements", for:["ADMIN","ACCOUNT MANAGER"], /*icon: Assessment ,*/  src: "/assets/images/sidebar_icons_2.0/Over all Statement.png", subLink: "/overallreport" },
      // { name: "Daily Statement", for:["ADMIN"], /*icon: TextSnippet ,*/  src: "/assets/images/sidebar_icons_2.0/Daily Statement.png", subLink: "#" },
      // { name: "Monthly Statement", for:["ADMIN"], /*icon:CalendarMonth ,*/ src: "/assets/images/sidebar_icons_2.0/Monthly Statement.png", subLink: "#" },
      // { name: "Yearly Statement", for:["ADMIN"], /*icon: DateRange ,*/  src: "/assets/images/sidebar_icons_2.0/Yearly Statement.png", subLink: "#" },
      { name: "Barber Statement", for:["ADMIN","ACCOUNT MANAGER"], /*icon: Description ,*/  src: "/assets/images/sidebar_icons_2.0/driver Statement.png", subLink: "/driversreport" },
      { name: "Km Driven / Duration", for:["ADMIN","ACCOUNT MANAGER"], /*icon: Description ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Account Statement.png", subLink: "/kmdriven-duration-report" },
      // { name: "Barber Account Statement", for:["ADMIN"], /*icon: AccountBox ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Account Statement.png", subLink: "#" },
      // { name: "Corporate Invoice", for:["ADMIN"], /*icon: InsertDriveFile ,*/ src: "/assets/images/sidebar_icons_2.0/Corporate Invoice.png", subLink: "#" },
      // { name: "Sub Company Invoice",/*icon: InsertDriveFile,*/  src: "/assets/images/sidebar_icons_2.0/Sub-company Invoice.png", subLink: "#" },
      // { name: "Hotel Invoice",/*icon: InsertDriveFile,*/ src: "/assets/images/sidebar_icons_2.0/HOtel Invoice.png", subLink: "#" },
      // { name: "Expense Report", for:["ADMIN"], /*icon: Money ,*/src: "/assets/images/sidebar_icons_2.0/Expensive Report.png", subLink: "#" },
    ],
  },

  {
    name: "Ratings & Reviews",
   for:["ADMIN"],
   // icon: Reviews,
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/RAting.png",
    active: false,
    subMenu: [
      { name: "User Ratings", for:["ADMIN"], /*icon: StarHalf ,*/ src: "/assets/images/sidebar_icons_2.0/User Ratings.png", subLink: "/userratings" },
      { name: "Barber Ratings", for:["ADMIN"], /*icon: StarHalf ,*/ src: "/assets/images/sidebar_icons_2.0/Driver Rating.png", subLink: "/driverratings" },
    ],
  },

  {
    name: "Notification",
   for:["ADMIN"],
   //icon: NotificationsActive, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Notification.png",
    active: false,
    subMenu: [
      { name: "Sms Notification", for:["ADMIN"], /*icon: Sms ,*/  src: "/assets/images/sidebar_icons_2.0/SMS Notification.png", subLink: "/smsnotifications" },
      { name: "Mail Notification", for:["ADMIN"], /*icon: MarkEmailUnread,*/  src: "/assets/images/sidebar_icons_2.0/Mail Notification.png", subLink: "/mailnotifications" },
      { name: "Push Notification", for:["ADMIN"], /*icon: Send ,*/  src: "/assets/images/sidebar_icons_2.0/Push Notification.png", subLink: "/pushnotifications" },
    ],
  },

  {
    name: "Service Type",
    for:["ADMIN"],
   // icon: LocalTaxi,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/iconservice.png",
    link: "/servicetype",
    active: false,
  },

  {
    name: "Fare Management",
   for:["ADMIN"],
   //icon: Sell , 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Fare Management.png",
    active: false,
    subMenu: [
      { name: "Service Type Fare", for:["ADMIN"], /*icon: EmojiTransportation ,*/  src: "/assets/images/sidebar_icons_2.0/Service Type Fare.png", subLink: "/servicetypefare" },
      { name: "Zone Wise Fare", for:["ADMIN"], /*icon: NearMe ,*/ src: "/assets/images/sidebar_icons_2.0/Zone management.png", subLink: "/ServicetypeZonefare" },
      // { name: "Airport Transfer", for:["ADMIN"], /*icon: ConnectingAirports,*/  src: "/assets/images/sidebar_icons_2.0/Airport transfer.png", subLink: "#" },
      // { name: "Fare Discount", for:["ADMIN"], /*icon: Discount  , */ src: "/assets/images/sidebar_icons_2.0/Fare Discount.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Expenses Info",
  //  for:["ADMIN"],
 //icon: Info, 
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/Expenses Info.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Fuel", for:["ADMIN"], /*icon: LocalGasStation,*/ src: "/assets/images/sidebar_icons_2.0/Fuel.png", subLink: "#" },
  //     { name: "Food", for:["ADMIN"], /*icon: FoodBank ,*/ src: "/assets/images/sidebar_icons_2.0/Food.png", subLink: "#" },
  //     { name: "Beverage", for:["ADMIN"], /*icon: LocalCafe , */ src: "/assets/images/sidebar_icons_2.0/Beverages.png", subLink: "#" },
  //     { name: "Car Freshner", for:["ADMIN"], /*icon: Spa, */ src: "/assets/images/sidebar_icons_2.0/Car freshener.png", subLink: "#" },
  //     { name: "Car Accessories", for:["ADMIN"], /*icon: Construction ,*/  src: "/assets/images/sidebar_icons_2.0/Car Accessories.png", subLink: "#" },
  //   ],
  // },

    {
    name: "Earnings and Rewards",
   for:["ADMIN"],
 //icon: Wallet, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Earning and reward.png",
    active: false,
    subMenu: [
   //   { name: "Barber Rewards", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Reward.png", subLink: "/driver-rewards" },
      { name: "Barber Earnings", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Earnings.png", subLink: "/driver-earnings" },
      { name: "Barber Pending Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutrecords" },
      { name: "Barber Approved Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutsapproved" },
      { name: "Barber Rejected Cashouts", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Record.png", subLink: "/cashoutsrejected" }        
      //    { name: "Cashout Sheets", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Cashout Sheet.png", subLink: "/cashoutsheets" },
      //  { name: "Hotel Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/   src: "/assets/images/sidebar_icons_2.0/User Wallet.png", subLink: "#" },
    ],
  },

  {
    name: "Wallet Management",
   for:["ADMIN"],
 //icon: Wallet, 
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Reward management.png",
    active: false,
    subMenu: [
   { name: "Users Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/User Reward.png", subLink: "/user-wallet" },
  // { name: "User Rewards Settings", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/User reward setting.png", subLink: "/user-reward-settings" },
  //  { name: "Barber Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/  src: "/assets/images/sidebar_icons_2.0/Driver Wallet.png", subLink: "/driver-wallet" },
  //  { name: "Hotel Wallet", for:["ADMIN"], /*icon: AccountBalanceWallet ,*/   src: "/assets/images/sidebar_icons_2.0/User Wallet.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Documents",
  //  for:["ADMIN"],
  //  //icon: DocumentScanner,
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/Documents.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Barber Documents", for:["ADMIN"], /*icon: DocumentScanner,*/ src: "/assets/images/sidebar_icons_2.0/Driver Document.png", subLink: "#" }
  //   ],
  // },

  {
    name: "Marketing",
    isCollapsible: true,
    for:["ADMIN"],
   //icon: Storefront,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Marketing.png",
    active: false,
    subMenu: [
      { name: "Promocodes", for:["ADMIN"], /*icon:Key ,*/  src: "/assets/images/sidebar_icons_2.0/Promo code.png", subLink: "/promocodes" },
     // { name: "Refer & Earn", for:["ADMIN"], /*icon: Handshake ,*/ src: "/assets/images/sidebar_icons_2.0/Refer and earn.png", subLink: "#" },
     // { name: "Loyalty", for:["ADMIN"], /*icon: Loyalty,*/src: "/assets/images/sidebar_icons_2.0/Loyalty.png", subLink: "#" },
    ],
  },

  // {
  //   name: "Customer Care Portal",
  //   isCollapsible: false,
  //  for:["ADMIN"],
 //icon: SupportAgent ,
  //   link: "#",
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/Customer Care.png",
  //   active: false,
  // },
  {
    name: "Bank Settings",
    isCollapsible: true,
    for:["ADMIN"],
    // icon: Settings ,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Bank Setting.png",
    active: false,
    subMenu: [
      { name: "Banks Available", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Bank available.png", subLink: "/available_banks" },
      { name: "Account type Settings", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebar_icons_2.0/Account type setting.png", subLink: "/account-type-settings" },
             ],
  },

  {
    name: "Settings",
    isCollapsible: true,
    for:["ADMIN","DISPATCHER","ACCOUNT MANAGER"],
    // icon: Settings ,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Setting.png",
    active: false,
    subMenu: [
      { name: "Admin Commission Settings", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Driver platfrom Fee.png", subLink: "/admin-commission-settings" },
     // { name: "Banks Available", for:["ADMIN"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Driver platfrom Fee.png", subLink: "/available_banks" },
      { name: "Banner Template Management", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebar_icons_2.0/bannerImage.png", subLink: "/BannerTemplateManage" },
      { name: "Site Settings", for:["ADMIN"], /*icon: SettingsApplications ,*/  src: "/assets/images/sidebar_icons_2.0/Site setting.png", subLink: "/site-settings" },
    //  { name: "Payment Settings", for:["ADMIN"], /*icon: Payments ,*/  src: "/assets/images/sidebar_icons_2.0/Payment Settings.png", subLink: "/payment-settings" },
      { name: "Business Settings", for:["ADMIN"], /*icon: BusinessCenter ,*/  src: "/assets/images/sidebar_icons_2.0/Business Settings.png", subLink: "/business-settings" },
      { name: "Change Password", for:["ADMIN","DISPATCHER","ACCOUNT MANAGER"], /*icon:Password ,*/ src: "/assets/images/sidebar_icons_2.0/Change Password.png", subLink: "/change-password" },
    // { name: "Legal Settings", for:["ADMIN"], /*icon: Policy,*/  src: "/assets/images/sidebar_icons_2.0/Legal Settings.png", subLink: "/legal-settings" },
    // Make Legal Settings itself collapsible
    { 
      name: "Legal Settings", 
      for:["ADMIN"], 
      isCollapsible: true,
      src: "/assets/images/sidebar_icons_2.0/Legel Setting.png",
      open: false,
      active: false,
      subMenu: [
        { 
          name: "Terms & Conditions", 
          for:["ADMIN"], 
          src: "/assets/images/sidebar_icons_2.0/Terms and conditions.png", 
          subLink: "/terms-conditions" 
        },
        { 
          name: "Privacy Policy", 
          for:["ADMIN"], 
          src: "/assets/images/sidebar_icons_2.0/Privacy policy.png", 
          subLink: "/privacy-policy" 
        }
      ]
    }
    ],
  },

  // {
  //   name: "CMS Settings",
  //  for:["ADMIN"],
  //  icon: AppSettingsAlt ,
  //   isCollapsible: true,
  //   open: false,
  //   src: "/assets/images/sidebar_icons_2.0/CMS Settings.png",
  //   active: false,
  //   subMenu: [
  //     { name: "Trip Notes", for:["ADMIN"], /*icon: AirlineStops ,*/  src: "/assets/images/sidebar_icons_2.0/Trip Notes.png", subLink: "#" },
  //     { name: "Trip Ratings", for:["ADMIN"], /*icon: ThumbsUpDown ,*/  src: "/assets/images/sidebar_icons_2.0/Trip Ratings.png", subLink: "#" },
  //     { name: "Other Contents", for:["ADMIN"], /*icon: Comment ,*/  src: "/assets/images/sidebar_icons_2.0/Other Contents.png", subLink: "#" },
  //   ],
  // },

// for corporate users

  {
    name: "Dashboard",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Dashboard.png",
    link: "/dashboard_corporate",
    active: false,
  },

  {
    name: "Groups",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Group.png",
    link: "/corporate_group",
    active: false,
  },
  {
    name: "Employees",
   for:["CORPORATE"],
    //icon: Dashboard,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Employee.png",
    link: "/corporate_employee",
    active: false,
  },

  {
    name: "Reports",
    isCollapsible: true,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Report.png",
    for:["CORPORATE"],
 // icon: Report, 
    active: false,
    subMenu: [
      { name: "Overall Ride Statements", for:["CORPORATE"], /*icon: Assessment ,*/  src: "/assets/images/sidebar_icons_2.0/Over all Statement.png", subLink: "/overallreport_corp" },
      { name: "Daily Statement", for:["CORPORATE"], /*icon: TextSnippet ,*/  src: "/assets/images/sidebar_icons_2.0/Daily statement.png", subLink: "/dailytripreport_corp" },
      { name: "Monthly Statement", for:["CORPORATE"], /*icon:CalendarMonth ,*/ src: "/assets/images/sidebar_icons_2.0/Monthly statement.png", subLink: "/monthlytripreport_corp" },
      { name: "Yearly Statement", for:["CORPORATE"], /*icon: DateRange ,*/  src: "/assets/images/sidebar_icons_2.0/Yearly statement.png", subLink: "/yearlytripreport_corp" },
],},

  {
    name: "Sign Out",
    for:["ADMIN","DISPATCHER","ACCOUNT MANAGER","SUB COMPANY" ,"CORPORATE"],
    //  icon: ExitToApp,
    isCollapsible: false,
    open: false,
    src: "/assets/images/sidebar_icons_2.0/Sign Out.png",
    link: "#",
    active: false,
  },
];

export default list;
